module.exports = __webpack_public_path__ + "img/priscilla-logo-w.a70a3dcb.svg";